module.exports = __webpack_public_path__ + "static/img/favorite-selected.57bcfe9.png";